import { render } from "./SkeletonUnNFT.vue?vue&type=template&id=221e27b4"
import script from "./SkeletonUnNFT.vue?vue&type=script&lang=js"
export * from "./SkeletonUnNFT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__